import loadable from "@loadable/component"
import { useState, useCallback } from "react"

import Modal from "components/modal"
import { retry } from "helpers/application"
import useWindowDimensions from "helpers/window-dimensions"

const Content = loadable(() => retry(() => import("./content")))

const Popup = () => {
  const [showContent, setShowContent] = useState(false)
  const afterShow = useCallback(() => setShowContent(true), [])

  const { isMobile } = useWindowDimensions()

  if (isMobile) return null

  return (
    <Modal
      afterShow={afterShow}
      contentClassName="pb-56 desktop:pb-2 pt-0 px-16 desktop:px-24"
      height="100%"
      show="#show-cart-item"
      width="600px"
    >
      <div className="flex flex-col" data-cy="cart-atc-modal">
        {showContent && <Content />}
      </div>
    </Modal>
  )
}

export default Popup
